import { connect } from "react-redux";

import { setParameter } from "../model/Think_Green";
import WaermerueckgewinnungParameter from "./WaermerueckgewinnungParameter";

export default connect(state => ({
	parameter: state.think_green.waermerueckgewinnung.parameter,
	units: state.units
}), dispatch => ({
	setRueckfuehrungsIndex: value => dispatch(setParameter("rueckfuehrungsIndex", value)),
	setHeizmaterialIndex: value => dispatch(setParameter("heizmaterialIndex", value)),
	setNutzungszeitraumWRG: value => dispatch(setParameter("nutzungszeitraumWRG_percent", value)),
	setHeizungWirkungsgrad: value => dispatch(setParameter("heizungWirkungsgrad_percent", value)),
	setKaltesWasserEin: value => dispatch(setParameter("kaltesWasserEin_degC", value)),
	setWarmesWasserAus: value => dispatch(setParameter("warmesWasserAus_degC", value))
}))(WaermerueckgewinnungParameter);
